import React from 'react';
import { motion } from 'framer-motion';
export function Solution() {
  return <section id="solution" className="py-24 bg-stone-900 text-stone-50" data-id="element-1618">
      <div className="max-w-6xl mx-auto px-6" data-id="element-1619">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-1620">
          <p className="font-mono text-xs uppercase tracking-widest text-stone-400 mb-6" data-id="element-1621">
            The Solution
          </p>

          <h2 className="font-serif text-4xl md:text-5xl tracking-tight leading-[1.1] text-stone-50 mb-6 max-w-3xl" data-id="element-1622">
            From email chaos to instant infrastructure
          </h2>

          <p className="text-lg text-stone-400 leading-relaxed mb-16 max-w-2xl" data-id="element-1623">
            BlockQuote replaces the entire manual quoting workflow with
            real-time infrastructure. What took days now takes seconds.
          </p>

          {/* Workflow Diagram */}
          <div className="border border-stone-700" data-id="element-1624">
            {/* Header */}
            <div className="grid grid-cols-2 border-b border-stone-700" data-id="element-1625">
              <div className="p-4 border-r border-stone-700" data-id="element-1626">
                <p className="font-mono text-xs uppercase tracking-widest text-stone-500" data-id="element-1627">
                  Before: Manual Process
                </p>
              </div>
              <div className="p-4" data-id="element-1628">
                <p className="font-mono text-xs uppercase tracking-widest text-stone-500" data-id="element-1629">
                  After: BlockQuote
                </p>
              </div>
            </div>

            {/* Step 1 */}
            <div className="grid grid-cols-2 border-b border-stone-700" data-id="element-1630">
              <div className="p-6 border-r border-stone-700" data-id="element-1631">
                <div className="flex items-start gap-4" data-id="element-1632">
                  <span className="font-mono text-xs text-stone-500 mt-1" data-id="element-1633">
                    01
                  </span>
                  <div data-id="element-1634">
                    <p className="text-stone-300 font-medium mb-1" data-id="element-1635">
                      Email RFP received
                    </p>
                    <p className="text-sm text-stone-500" data-id="element-1636">
                      Unstructured data, manual parsing required
                    </p>
                  </div>
                </div>
              </div>
              <div className="p-6 bg-stone-800/50" data-id="element-1637">
                <div className="flex items-start gap-4" data-id="element-1638">
                  <span className="font-mono text-xs text-red-600 mt-1" data-id="element-1639">
                    01
                  </span>
                  <div data-id="element-1640">
                    <p className="text-stone-50 font-medium mb-1" data-id="element-1641">
                      Instant quote request
                    </p>
                    <p className="text-sm text-stone-400" data-id="element-1642">
                      Structured input, real-time pricing
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Step 2 */}
            <div className="grid grid-cols-2 border-b border-stone-700" data-id="element-1643">
              <div className="p-6 border-r border-stone-700" data-id="element-1644">
                <div className="flex items-start gap-4" data-id="element-1645">
                  <span className="font-mono text-xs text-stone-500 mt-1" data-id="element-1646">
                    02
                  </span>
                  <div data-id="element-1647">
                    <p className="text-stone-300 font-medium mb-1" data-id="element-1648">
                      Manual pricing lookup
                    </p>
                    <p className="text-sm text-stone-500" data-id="element-1649">
                      Check PMS, spreadsheets, rate cards
                    </p>
                  </div>
                </div>
              </div>
              <div className="p-6 bg-stone-800/50" data-id="element-1650">
                <div className="flex items-start gap-4" data-id="element-1651">
                  <span className="font-mono text-xs text-red-600 mt-1" data-id="element-1652">
                    02
                  </span>
                  <div data-id="element-1653">
                    <p className="text-stone-50 font-medium mb-1" data-id="element-1654">
                      Auto-generated packages
                    </p>
                    <p className="text-sm text-stone-400" data-id="element-1655">
                      Good / Better / Best within policy
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Step 3 */}
            <div className="grid grid-cols-2 border-b border-stone-700" data-id="element-1656">
              <div className="p-6 border-r border-stone-700" data-id="element-1657">
                <div className="flex items-start gap-4" data-id="element-1658">
                  <span className="font-mono text-xs text-stone-500 mt-1" data-id="element-1659">
                    03
                  </span>
                  <div data-id="element-1660">
                    <p className="text-stone-300 font-medium mb-1" data-id="element-1661">
                      48–72 hour response
                    </p>
                    <p className="text-sm text-stone-500" data-id="element-1662">
                      Back-and-forth negotiation via email
                    </p>
                  </div>
                </div>
              </div>
              <div className="p-6 bg-stone-800/50" data-id="element-1663">
                <div className="flex items-start gap-4" data-id="element-1664">
                  <span className="font-mono text-xs text-red-600 mt-1" data-id="element-1665">
                    03
                  </span>
                  <div data-id="element-1666">
                    <p className="text-stone-50 font-medium mb-1" data-id="element-1667">
                      Instant hold + proposal
                    </p>
                    <p className="text-sm text-stone-400" data-id="element-1668">
                      Inventory secured, terms standardized
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Step 4 */}
            <div className="grid grid-cols-2" data-id="element-1669">
              <div className="p-6 border-r border-stone-700" data-id="element-1670">
                <div className="flex items-start gap-4" data-id="element-1671">
                  <span className="font-mono text-xs text-stone-500 mt-1" data-id="element-1672">
                    04
                  </span>
                  <div data-id="element-1673">
                    <p className="text-stone-300 font-medium mb-1" data-id="element-1674">
                      Lost groups + leakage
                    </p>
                    <p className="text-sm text-stone-500" data-id="element-1675">
                      No audit trail, margin captured by wholesalers
                    </p>
                  </div>
                </div>
              </div>
              <div className="p-6 bg-stone-800/50" data-id="element-1676">
                <div className="flex items-start gap-4" data-id="element-1677">
                  <span className="font-mono text-xs text-red-600 mt-1" data-id="element-1678">
                    04
                  </span>
                  <div data-id="element-1679">
                    <p className="text-stone-50 font-medium mb-1" data-id="element-1680">
                      One-click contract
                    </p>
                    <p className="text-sm text-stone-400" data-id="element-1681">
                      Direct booking, full audit trail, zero leakage
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Summary row */}
            <div className="grid grid-cols-2 border-t border-stone-700" data-id="element-1682">
              <div className="p-6 border-r border-stone-700" data-id="element-1683">
                <p className="font-mono text-sm text-stone-500" data-id="element-1684">
                  Result:{' '}
                  <span className="text-stone-300" data-id="element-1685">
                    Days of delay, margin loss
                  </span>
                </p>
              </div>
              <div className="p-6 bg-stone-800/50" data-id="element-1686">
                <p className="font-mono text-sm text-stone-400" data-id="element-1687">
                  Result:{' '}
                  <span className="text-red-600" data-id="element-1688">
                    Seconds to quote, direct revenue
                  </span>
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}